import ArrowTriangleheadSwap from './ArrowTriangleheadSwap';

export default ArrowTriangleheadSwap;
